var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      ref: "dropdowncoruiItem",
      staticClass: "nav-item nav-dropdown",
      class: _vm.open ? "open" : "",
    },
    [
      _c(
        "div",
        {
          staticClass: "nav-link nav-dropdown-toggle",
          class: _vm.noTranslate(),
          on: { click: _vm.handleClick },
        },
        [_c("i", { class: _vm.classIcon }), _vm._v(" " + _vm._s(_vm.item.name))]
      ),
      _c("ul", { staticClass: "nav-dropdown-items" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }